import React from 'react';
import { FormattedMessage } from 'react-intl';
import { appNotification } from '../../containers/App/appNotification';
import { createLocalNotification } from '../../containers/App/utils';

const notification = createLocalNotification('Agent', {
    error: (
        <FormattedMessage
            id='front-app/Agent/Notification/Error:title'
            defaultMessage='Agent Error'
        />
    ),
    warning: (
        <FormattedMessage
            id='front-app/Agent/Notification/Warning:title'
            defaultMessage='Agent Warning'
        />
    ),
    info: (
        <FormattedMessage
            id='front-app/Agent/Notification/Info:title'
            defaultMessage='Agent Info'
        />
    ),
    success: (
        <FormattedMessage
            id='front-app/Agent/Notification/Info:title'
            defaultMessage='Agent Info'
        />
    ),
});

export const agentNotifications = {
    createdSuccessfully: notification.success(appNotification.texts.createdSuccessfully),
    updatedSuccessfully: notification.success(appNotification.texts.updatedSuccessfully),
    unknownError: (details?: JSX.Element | string) => (
        notification.error(appNotification.texts.unknownError(details))
    ),
};
